import type { Seat } from '../types/api';

/**
 * Human-facing seat label following Kenyan PSV convention: the 2nd seat is
 * "1X" and seats after it shift down by one, so a 14-seater reads
 * 1, 1X, 2, 3, ... 13. The stored `seat_number` is unchanged — this is a
 * display label only, matching the backend `seat_label`.
 */
export function seatLabel(seatNumber: number | null | undefined): string {
  if (seatNumber == null || Number.isNaN(seatNumber)) return String(seatNumber);
  if (seatNumber <= 1) return String(seatNumber);
  if (seatNumber === 2) return '1X';
  return String(seatNumber - 1);
}

/** The seat a booking sits on, as text for a table cell.
 *
 * Prefers the `label` the API sends so every surface agrees on the
 * convention, and computes it only as a fallback. When the booking carries no
 * seat at all this renders an em dash — the column used to print the seat's
 * raw database id, which means nothing to the person reading it. */
export function bookingSeatText(booking: { seat_info?: Seat }): string {
  const seat = booking.seat_info;
  if (!seat) return '—';
  return seat.label ?? seatLabel(seat.seat_number);
}
